// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.8_webpack@5.112.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./iconcolors.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/.pnpm/vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("a94ec5c8", content, false, {"sourceMap":false,"shadowMode":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.8_webpack@5.112.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./iconcolors.css", function() {
     var newContent = require("!!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.8_webpack@5.112.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./iconcolors.css");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}